import { FALLBACK_RATES } from '../services/currencyService';

// Кэш для хранения последних полученных курсов
let cachedRates = null;

// Функция для установки курсов (вызывать после загрузки из API)
export const setExchangeRates = (rates) => {
  cachedRates = rates;
};

// Простая функция конвертации в USD
export const toUSD = (value) => {
  if (value === undefined || value === null) return 0;

  let amount = 0;
  let currency = 'USD';

  // Если объект с валютой
  if (typeof value === 'object' && value !== null && 'value' in value) {
    amount = parseFloat(value.value) || 0;
    currency = value.currency || 'USD';
  }
  // Если число или строка
  else {
    amount = parseFloat(value) || 0;
    currency = 'USD';
  }

  // Если это уже USD
  if (currency === 'USD') return amount;

  // Используем актуальные курсы или fallback
  console.log('cachedRates', cachedRates)

  const rates = cachedRates || FALLBACK_RATES;
  const rate = rates[currency];

  if (!rate) {
    console.warn(`No exchange rate for ${currency}, using 1:1`);
    return amount;
  }

  // Конвертируем в USD (делим на курс, т.к. rates показывают сколько USD стоит 1 единица валюты)
  return amount / rate;
};

// Функция для получения числа (просто обертка)
export const toNumber = (value) => {
  if (value === undefined || value === null) return 0;

  if (typeof value === 'object' && value !== null && 'value' in value) {
    return parseFloat(value.value) || 0;
  }

  return parseFloat(value) || 0;
};